import parseProject from 'App/resources/parsers/project';

angular.module('upResources').service('ParseCampaign', function () {
	return parseProject;
});
